exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dropzone[data-v-1ab1dde2] {\n  background-color: #f6f6f6 !important;\n}\n#dropzone .dz-message[data-v-1ab1dde2] {\n  padding: 10px;\n  background-color: transparent;\n  color: #444444;\n  font-weight: 600;\n}", ""]);

// exports
